import { render, staticRenderFns } from "./LogisticsPersonalStats.vue?vue&type=template&id=80dbb2dc&scoped=true&"
import script from "./LogisticsPersonalStats.vue?vue&type=script&lang=js&"
export * from "./LogisticsPersonalStats.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsPersonalStats.vue?vue&type=style&index=0&id=80dbb2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dbb2dc",
  null
  
)

export default component.exports